// extracted by mini-css-extract-plugin
export default {"app":"Island_app__nv3eP","path":"Island_path__7vzn4","player":"Island_player__mfk0A"};